import { IEnvironment } from './environment.interface';

export const environment: IEnvironment = {
  production: true,
  front: {
    host: 'posty5.com',
    href: 'https://posty5.com',
    appName: 'Posty 5',
  },
  back: {
    host: 'api.posty5.com',
    href: 'https://api.posty5.com/',
    i18n: 'https://api.posty5.com/i18n/posty5/',
    // i18n: 'http://localhost:4000/i18n/posty5/',

    apiBaseUrl: 'https://api.posty5.com/api/',
    qrCode: {
      templateRenderBaseURL:
        'https://api.posty5.com/api/qr-code-template/public-render/',
    },
  },
  google: {
    recaptchaKey: '6LcJ52EqAAAAAIhR5IXpKsTmUrgTXtIJrUfK0XLk',
    client_id:
      '674783926772-0gg33mpak46rvul7en9a0r0bu4mv9fip.apps.googleusercontent.com',
    gtm: 'GTM-WK26TV8Z',
    adsense: {
      toolsTop: 8755768087,
      toolsBottom: 5382960288,
      landingPostAuthor: 5981726086,
      landingPostUnderTitle: 5746461361,
      landingPostUnderDetailsBox1: 6911664371,
      landingPostUnderDetailsBox2: 2239327168,
      landingPostUnderCommentsBox: 1915893536,
    },
  },
  facebook: {
    app_id: 115935942290301,
  },
  appAssetsVersion: {
    version:1746971454328,
    buildDate:"2025-05-11T13:50:54.328Z"
  },
};
